import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'cv-cxone-challenges-lead-renderer',
    templateUrl: './cxone-challenges-lead-renderer.component.html',
    styleUrls: ['./cxone-challenges-lead-renderer.component.scss']
})
export class CxoneChallengesLeadCellRendererComponent implements AgRendererComponent {

    params: ICellRendererParams;
    value: string;
    popOverData = [];
    firstParticipant: string;

    agInit(params: ICellRendererParams) {
        this.params = this.getLeadValue(params);
        this.value = this.getLeadValue(params);
        this.participantsSamePosition(params);
    }
    
    getLeadValue(param) {
        if (param.value != undefined && param.value != null && param.value.length != 0) {
            return param.value[0].Name;
        }
        return "--";
    }    

    openPopover(popover: NgbPopover): void {
        popover.open();
        return;
    }

    participantsSamePosition(data) {
        const participantsData = [...data.value];
        const sortedArray = participantsData
        .filter(({ Place, ViewScore }) => Place > 0 && ViewScore !== null)
        .sort((a, b) => {
            return a.Place - b.Place  || a.Name.localeCompare(b.Name);
        });
        this.firstParticipant = sortedArray[0]?.Name;
        const filteredArray = sortedArray.slice(1).filter(participant => participant.Place === sortedArray[0]?.Place);
        this.popOverData = filteredArray;
        return filteredArray;
    }

    refresh(params: ICellRendererParams) {
        this.params = this.getLeadValue(params);
        this.value = this.getLeadValue(params);
        return true;
    }
}
